export default function printProductAnual(year, type = '') {
  const token = localStorage.getItem("token");
  printAnual(token, year || '', type)
}
function printAnual(token, year, type) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/produtos-logs/find/per/year?auth=${token}&year=${year}&type=${type}`
  );
}